/**
 * Created by daniel on 16/04/17.
 *
 * Decides which component should be rendered and passes appropriate props
 * Does all necessary calculations, state management, and event management.
 * Expects own component info to be passed as props - either on creation or by redux
 */

import React, {Component} from 'react';
import {connect} from "react-redux";
import {TEMPLATE_COMPONENTS} from "./primitives/index";
import ConnectedContentContainer from "./ContentContainer";
import {setUiDraggedContentItem, setUiDropzoneCoords, setUiSelectedContentItem} from "../state/ui/actions";
import {getContentItem, getContentItemChildren, hasHiddenAncestor} from "../state/content/selectors";
import {getUiDraggedItem, getUiDropzoneCoords, getUiHoveredItem, getUiSelectedItem} from "../state/ui/selectors";
import * as _ from "lodash";
import {DATA_TRANSFER_TYPE, DRAG_TYPE} from "../dragDropDefinitions";
import {getContentDefinition, getContentDefinitions} from "../state/config/selectors";
import './ContentContainer.css';
import {createContentItem, moveContentItem, updateContentItem} from "../state/content/actions";

class ContentContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      ...this.calculateState(props),
      highlight: false,
    };

    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleUpdateContentFrame = this.handleUpdateContentFrame.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.calculateState = this.calculateState.bind(this);
  }
  
  handleMouseOver(e) {
    e.preventDefault();
    if (this.props.selectedItem) {
      e.stopPropagation();
      return false;
    }
    if (this.state.hoverable) {
      e.stopPropagation();
      this.setState({hovered: true})
    }
  };
  
  handleMouseOut(e) {
    e.preventDefault();
    //e.stopPropagation();
    this.setState({hovered: false})
  };
  
  handleOnClick(e) {
    e.preventDefault();
    if (this.props.selectedItem) {
      e.stopPropagation();
      return false;
    }
    
    if (this.state.selectable) {
      e.stopPropagation();
      this.handleUpdateContentFrame();
    }
  };
  
  handleDragOver(e) {
    // Determine whether we will accept this drag - if yes stop propagation, otherwise let it continue down
    // Let bubble through if not this one
  
    if (this.props.selectedItem) {
      e.stopPropagation();
      return false;
    }
    
    if(this.state.acceptDragSelf || this.state.acceptDragParent) {
      e.preventDefault();
      e.stopPropagation();
      
      // Work out correct drag cursor - either "copy" or "move"
      if (e.ctrlKey) {
        e.dataTransfer.dropEffect = "copy";
      } else {
        e.dataTransfer.dropEffect = "move";
      }
  
      // Work out cursor location on target
      let thisRect = e.currentTarget.getBoundingClientRect();
      let editorRect = document.getElementById("canvas-element").getBoundingClientRect();
      let pointerPosition = {
        x: (e.clientX - thisRect.left)/(thisRect.right - thisRect.left),
        y: (e.clientY - thisRect.top)/(thisRect.bottom - thisRect.top),
      };
      let loc = {
        x : pointerPosition.x > 0.5 ? "right" : "left",
        y : pointerPosition.y > 0.5 ? "bottom" : "top",
      };
  
      let highlight; // all,top, right, bottom, left
      
      // Cell-type elements need listing here
      let isCell = this.props.myProps.configPrimitive === TEMPLATE_COMPONENTS.CELL_ITEM.id
        || this.props.myProps.configPrimitive === TEMPLATE_COMPONENTS.RICH_TEXT.id
        || this.props.myProps.configPrimitive === TEMPLATE_COMPONENTS.IMAGE_ITEM.id
        || this.props.myProps.configPrimitive === TEMPLATE_COMPONENTS.TOC_ITEM.id
        || this.props.myProps.configPrimitive === TEMPLATE_COMPONENTS.COLUMN.id;
  
      // Is it going to this or the the parent?
      // Does this element already have children?
      if (this.state.acceptDragSelf) {
        if (this.props.childProps.length === 0) {
          highlight = "all";
        } else {
          highlight = isCell ? "right" : "bottom";
        }
      } else if (this.state.acceptDragParent) {
        // need to know where in element to go
        if (isCell) {
          // Need to look left / right
          highlight = loc.x;
        } else {
          // Need to look up / down
          highlight = loc.y;
        }
      }
      
      let highlightMatchState = _.isEqual(this.state.highlight, highlight);
      if (!highlightMatchState) this.setState({highlight});
      
      let highlightFrame;
      
      switch (highlight) {
        case "all":
          highlightFrame = {
            top: thisRect.top - editorRect.top,
            left: thisRect.left- editorRect.left,
            width: thisRect.right - thisRect.left,
            height:thisRect.bottom - thisRect.top,
          };
          break;
        case "top":
          highlightFrame = {
            top: thisRect.top - editorRect.top - 20,
            left: thisRect.left- editorRect.left - 20,
            width: thisRect.right - thisRect.left + 40,
            height: 40,
          };
          break;
        case "right":
          highlightFrame = {
            top: thisRect.top - editorRect.top - 20,
            left: thisRect.right - editorRect.left - 20,
            width: 40,
            height:thisRect.bottom - thisRect.top + 40,
          };
          break;
        case "bottom":
          highlightFrame = {
            top: thisRect.bottom - editorRect.top - 20,
            left: thisRect.left- editorRect.left - 20,
            width: thisRect.right - thisRect.left + 40,
            height: 40,
          };
          break;
        case "left":
          highlightFrame = {
            top: thisRect.top - editorRect.top - 20,
            left: thisRect.left- editorRect.left - 20,
            width: 40,
            height:thisRect.bottom - thisRect.top + 40,
          };
          break;
        default:
      }
      highlightFrame.top += 56;
      let currentFrame = this.props.dropzoneCoords;
      let matches = _.isEqual(currentFrame, highlightFrame);
      if (!matches) this.props.dispatch(setUiDropzoneCoords(highlightFrame));
    }
  };
  
  handleDrop(e) {
  
    if (this.props.selectedItem) {
      e.stopPropagation();
      return false;
    }
    // Handle the drop when it happens, assuming we want it
    //console.log("dropped");
    let type = e.dataTransfer.getData(DATA_TRANSFER_TYPE.DRAG_TYPE);
    
    if (this.state.acceptDragSelf) {
      e.preventDefault();
      e.stopPropagation();
      
      // TODO enable duplication with CTRL key
      // Just append it - simple
      if (type === DRAG_TYPE.MOVING_ITEM) {
        // Update item parent to this
        this.props.dispatch(moveContentItem(this.props.currentDrag.contentId, this.props.myProps.contentId));
      } else {
        // Create new here
        this.props.dispatch(this.props.createItem(this.props.myProps.contentId, null, this.props.currentDrag.configId));
      }
  
      this.props.dispatch(setUiDraggedContentItem(null));
      this.props.dispatch(setUiDropzoneCoords(null));
    } else if (this.state.acceptDragParent) {
      e.stopPropagation();
      e.stopPropagation();
      if (type === DRAG_TYPE.MOVING_ITEM) {
        // Update item parent to this
        if (this.state.highlight === "left" || this.state.highlight === "top") {
          this.props.dispatch(moveContentItem(this.props.currentDrag.contentId, this.props.myProps.contentParentId, this.props.myProps.contentId, false));
        } else if (this.state.highlight === "right" || this.state.highlight === "bottom") {
          this.props.dispatch(moveContentItem(this.props.currentDrag.contentId, this.props.myProps.contentParentId, this.props.myProps.contentId, true));
        }
      } else {
        // Create new here
        if (this.state.highlight === "left" || this.state.highlight === "top") {
          this.props.dispatch(this.props.createItem(this.props.myProps.contentParentId, this.props.myProps.contentId, this.props.currentDrag.configId, false));
        } else if (this.state.highlight === "right" || this.state.highlight === "bottom") {
          this.props.dispatch(this.props.createItem(this.props.myProps.contentParentId, this.props.myProps.contentId, this.props.currentDrag.configId, true));
        }
      }
  
      this.props.dispatch(setUiDraggedContentItem(null));
      this.props.dispatch(setUiDropzoneCoords(null));
    }
    
    //this.props.dispatch(createContentItem(this.props.id, null, e.dataTransfer.getData("editor/itemDefId"), getContentDefinitions(this.props.state)));
  };
  
  handleDragStart(e) {
    if (this.props.selectedItem) {
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
    if (this.state.draggable) {
      e.stopPropagation();
      this.props.dispatch(setUiSelectedContentItem(null));
      this.props.dispatch(setUiDraggedContentItem(this.props.myProps));
      e.dataTransfer.setData(DATA_TRANSFER_TYPE.DRAG_TYPE, DRAG_TYPE.MOVING_ITEM);
    } else {
      e.preventDefault();
      return false;
    }
  };
  
  handleDragEnd(e) {
    if (this.props.selectedItem) {
      e.stopPropagation();
      return false;
    }
    e.stopPropagation();
    e.preventDefault();
  };
  
  handleUpdate(content) {
    this.props.dispatch(
      updateContentItem(
        this.props.myProps.contentId,
        content,
        this.props.myProps,
        this.props.getConfig(this.props.myProps.configId)
      )
    );
  };
  
  handleUpdateContentFrame() {
    let matches = _.isEqual(this.props.selectedItem, {contentId: this.props.myProps.contentId});
    if (!matches) { this.props.dispatch(setUiSelectedContentItem(this.props.myProps.contentId)); }
  };
  
  componentWillReceiveProps(nextProps) {
    // Work out current interactivity
    let newState = this.calculateState(nextProps);
    let matches = _.isMatch(this.state, newState);
    if (!matches) this.setState({...newState});
  };
  
  calculateState(props) {
    let me = props.myProps;
    let parent = props.parentProps;
  
    // Work out if selectable
    let selectable = !props.hiddenAncestor && !me.editorLocked && me.editorSelectable;
    // Work out if hoverable
    let needsHover = me.editorSelectable || me.editorDraggable;
    let hoverable =  !props.hiddenAncestor && !me.editorLocked && !props.selectedItem && needsHover;
    // Work out if already hovered
    let hovered = props.isHovered;
    // Work out if draggable
    let draggable = !props.hiddenAncestor && !me.editorLocked && me.editorDraggable;
    // Work out if can be a drag target
    let dragTarget = !props.hiddenAncestor && !me.editorLocked && !me.contentHidden && me.editorDragTarget;
    let parentDragTarget = parent ? !parent.editorLocked && !parent.contentHidden && parent.editorDragTarget : false;
    
    // Work out if we accept the current drag object
    let dragging = false;
    let acceptDragSelf = false;
    let acceptDragParent = false;
  
    if (props.currentDrag) {
    
      let cd = props.currentDrag;
      //Is it me?
      if (cd.contentId === me.contentId) {
        dragging = true;
      }
    
      if (dragTarget) {
        props.currentDrag.editorAllowedParents.map((rule) => {
          acceptDragSelf = acceptDragSelf || _.isMatch(me, rule);
          return true;
        });
      }
      if (parentDragTarget) {
        props.currentDrag.editorAllowedParents.map((rule) => {
          acceptDragParent = acceptDragParent || _.isMatch(parent, rule);
          return true;
        });
      }
    }
    
    return {
      selectable,
      hoverable,
      hovered,
      draggable,
      dragTarget,
      parentDragTarget,
      dragging,
      acceptDragSelf,
      acceptDragParent,
    };
  };
  
  render() {
    // Build children
    let itemChildren = this.props.childProps;
    let children = [];
    if (itemChildren.length > 0) {
      children = itemChildren.map((item) => <ConnectedContentContainer contentId={item.contentId} key={item.contentId}/>);
    }
  
    // Assign events
    let eventHandlers = {
      onClick : this.handleOnClick,
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut,
      onDragStart: this.handleDragStart,
      onDragEnd: this.handleDragEnd,
      onDrop: this.handleDrop,
      onDragOver: this.handleDragOver,
    };
    
    // Choose correct style
    let additionalClasses = [];
    
    if (this.state.dragging) {
      additionalClasses.push("editor-dragged");
    }
    if (this.state.hovered) {
      additionalClasses.push("editor-hovered");
    }
    if (this.props.myProps.contentHidden) {
      additionalClasses.push("editor-hidden");
    }
    
  
    let calcProps = {
      ...this.props.myProps,
      viewClass: this.props.myProps.viewClass + " " + additionalClasses.join(" "),
      viewAttributes: {
        ...this.props.myProps.viewAttributes,
        draggable: this.state.draggable,
        id: this.props.myProps.contentId,
      },
      children,
      eventHandlers,
      updateContent: this.handleUpdate,
      currentlySelected: this.props.selectedItem && (this.props.selectedItem.contentId === this.props.myProps.contentId),
      updateContentFrame: this.handleUpdateContentFrame,
    };
    
    // Find the correct constructor
    if (!calcProps.configPrimitive) return null;
    let primitives = TEMPLATE_COMPONENTS; // Webpack doesn't import otherwise
    let component = primitives[calcProps.configPrimitive].component;
    
    return React.createElement(
      component,
      calcProps,
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // Get own props, child props and parent props
  let myProps = getContentItem(state, ownProps.contentId);
  //TODO see if we can trim down how much is requested here - are IDs enough?
  let childProps = getContentItemChildren(state, ownProps.contentId);
  let parentProps = getContentItem(state, myProps.contentParentId);
  
  let isHovered = getUiHoveredItem(state) === ownProps.contentId;
  let selectedItem = getUiSelectedItem(state);
  
  let getConfig = (configId) => getContentDefinition(state, configId);
  let currentDrag = getUiDraggedItem(state);
  let dropzoneCoords = getUiDropzoneCoords(state);
  
  let createItem = (contentParentId, relativeToContentId, configId, moveBelow) => createContentItem(contentParentId, relativeToContentId, configId, getContentDefinitions(state), moveBelow);

  let hiddenAncestor = hasHiddenAncestor(state, ownProps.contentId);
  
  return {
    myProps,
    childProps,
    parentProps,
    isHovered,
    selectedItem,
    currentDrag,
    dropzoneCoords,
    getConfig,
    createItem,
    hiddenAncestor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentContainer);



// WEBPACK FOOTER //
// ./src/App/Editor/components/ContentContainer.js